import "./background-gradient.scss";

import React from "react";

const BackgroundGradient = ({ onMouseMove, x, y }) => {
  return (
    <div
      onMouseMove={onMouseMove}
      style={{ left: `${x}%`, top: `${y}%` }}
      className="background-gradient"
      aria-hidden="true"
    />
  );
};

export default BackgroundGradient;
